@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.corbettcode.allaboutrocks.components.layouts.MarkdownLayout as _com_corbettcode_allaboutrocks_components_layouts_MarkdownLayout
import com.corbettcode.allaboutrocks.components.layouts.PageLayout as _com_corbettcode_allaboutrocks_components_layouts_PageLayout
import com.corbettcode.allaboutrocks.pages.AboutPage as _com_corbettcode_allaboutrocks_pages_AboutPage
import com.corbettcode.allaboutrocks.pages.AwesomePlacesPage as _com_corbettcode_allaboutrocks_pages_AwesomePlacesPage
import com.corbettcode.allaboutrocks.pages.ContactUsPage as _com_corbettcode_allaboutrocks_pages_ContactUsPage
import com.corbettcode.allaboutrocks.pages.HomePage as _com_corbettcode_allaboutrocks_pages_HomePage
import com.corbettcode.allaboutrocks.pages.LearnBooksPage as _com_corbettcode_allaboutrocks_pages_LearnBooksPage
import com.corbettcode.allaboutrocks.pages.LearnIdentifyRocksPage as _com_corbettcode_allaboutrocks_pages_LearnIdentifyRocksPage
import com.corbettcode.allaboutrocks.pages.LearnTumbleRocksPage as _com_corbettcode_allaboutrocks_pages_LearnTumbleRocksPage
import com.corbettcode.allaboutrocks.pages.ResourcesPage as _com_corbettcode_allaboutrocks_pages_ResourcesPage
import com.corbettcode.allaboutrocks.pages.typesof.TheRockCyclePage as _com_corbettcode_allaboutrocks_pages_typesof_TheRockCyclePage
import com.corbettcode.allaboutrocks.pages.typesof.TypesOfAgatePage as _com_corbettcode_allaboutrocks_pages_typesof_TypesOfAgatePage
import com.corbettcode.allaboutrocks.pages.typesof.TypesOfCarnelianPage as _com_corbettcode_allaboutrocks_pages_typesof_TypesOfCarnelianPage
import com.corbettcode.allaboutrocks.pages.typesof.TypesOfChalcedonyPage as _com_corbettcode_allaboutrocks_pages_typesof_TypesOfChalcedonyPage
import com.corbettcode.allaboutrocks.pages.typesof.TypesOfEpidotePage as _com_corbettcode_allaboutrocks_pages_typesof_TypesOfEpidotePage
import com.corbettcode.allaboutrocks.pages.typesof.TypesOfIgneousPage as _com_corbettcode_allaboutrocks_pages_typesof_TypesOfIgneousPage
import com.corbettcode.allaboutrocks.pages.typesof.TypesOfJasperPage as _com_corbettcode_allaboutrocks_pages_typesof_TypesOfJasperPage
import com.corbettcode.allaboutrocks.pages.typesof.TypesOfMetamorphicPage as _com_corbettcode_allaboutrocks_pages_typesof_TypesOfMetamorphicPage
import com.corbettcode.allaboutrocks.pages.typesof.TypesOfPetrifiedWoodPage as _com_corbettcode_allaboutrocks_pages_typesof_TypesOfPetrifiedWoodPage
import com.corbettcode.allaboutrocks.pages.typesof.TypesOfQuartzPage as _com_corbettcode_allaboutrocks_pages_typesof_TypesOfQuartzPage
import com.corbettcode.allaboutrocks.pages.typesof.TypesOfSedimentaryPage as _com_corbettcode_allaboutrocks_pages_typesof_TypesOfSedimentaryPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "All About Rocks"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "com.corbettcode.allaboutrocks.components.layouts.MarkdownLayout",
            parentLayoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _com_corbettcode_allaboutrocks_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _com_corbettcode_allaboutrocks_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_HomePage()
        }
        ctx.router.register(
            "/about",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.initAboutPage(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_AboutPage()
        }
        ctx.router.register(
            "/awesome-places",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.initAwesomePlacesPage(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_AwesomePlacesPage()
        }
        ctx.router.register(
            "/contact-us",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.initContactUsPage(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_ContactUsPage()
        }
        ctx.router.register(
            "/learn_books",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.initLearnBooks(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_LearnBooksPage()
        }
        ctx.router.register(
            "/learn_identify_rocks",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.initLearnIdentifyRocks(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_LearnIdentifyRocksPage()
        }
        ctx.router.register(
            "/learn_tumble_rocks",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.initLearnTumbleRocks(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_LearnTumbleRocksPage()
        }
        ctx.router.register(
            "/resources",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.initResourcesPage(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_ResourcesPage()
        }
        ctx.router.register(
            "/types_of_rocks/PetrifiedWood",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.typesof.initTypesOfPetrifiedWood(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_typesof_TypesOfPetrifiedWoodPage()
        }
        ctx.router.register(
            "/types_of_rocks/agate",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.typesof.initTypesOfAgate(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_typesof_TypesOfAgatePage()
        }
        ctx.router.register(
            "/types_of_rocks/carnelian",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.typesof.initTypesOfCarnelian(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_typesof_TypesOfCarnelianPage()
        }
        ctx.router.register(
            "/types_of_rocks/chalcedony",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.typesof.initTypesOfChalcedony(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_typesof_TypesOfChalcedonyPage()
        }
        ctx.router.register(
            "/types_of_rocks/epidote",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.typesof.initTypesOfEpidote(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_typesof_TypesOfEpidotePage()
        }
        ctx.router.register(
            "/types_of_rocks/igneous",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.typesof.initTypesOfIgneous(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_typesof_TypesOfIgneousPage()
        }
        ctx.router.register(
            "/types_of_rocks/jasper",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.typesof.initTypesOfJasper(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_typesof_TypesOfJasperPage()
        }
        ctx.router.register(
            "/types_of_rocks/metamorphic",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.typesof.initTypesOfMetamorphic(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_typesof_TypesOfMetamorphicPage()
        }
        ctx.router.register(
            "/types_of_rocks/quartz",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.typesof.initTypesOfQuartz(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_typesof_TypesOfQuartzPage()
        }
        ctx.router.register(
            "/types_of_rocks/sedimentary",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.typesof.initTypesOfSedimentary(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_typesof_TypesOfSedimentaryPage()
        }
        ctx.router.register(
            "/types_of_rocks/the_rock_cycle",
            layoutId = "com.corbettcode.allaboutrocks.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.corbettcode.allaboutrocks.pages.typesof.initTheRockCycle(ctx)
            },
        ) { pageCtx -> 
            _com_corbettcode_allaboutrocks_pages_typesof_TheRockCyclePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("learn-book-title", com.corbettcode.allaboutrocks.pages.LearnBookTitleStyle)
        ctx.theme.registerStyle("learn-book-rating", com.corbettcode.allaboutrocks.pages.LearnBookRatingStyle)
        ctx.theme.registerStyle("page-content", com.corbettcode.allaboutrocks.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("markdown", com.corbettcode.allaboutrocks.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("footer", com.corbettcode.allaboutrocks.components.sections.FooterStyle)
        ctx.theme.registerStyle("nav-header", com.corbettcode.allaboutrocks.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("headline-text", com.corbettcode.allaboutrocks.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", com.corbettcode.allaboutrocks.SubheadlineTextStyle)
        ctx.theme.registerStyle("section-text", com.corbettcode.allaboutrocks.SectionTextStyle)
        ctx.theme.registerStyle("image-credit", com.corbettcode.allaboutrocks.ImageCreditStyle)
        ctx.theme.registerStyle("page-headline", com.corbettcode.allaboutrocks.PageHeadlineStyle)
        ctx.theme.registerStyle("page-section-title", com.corbettcode.allaboutrocks.PageSectionTitleStyle)
        ctx.theme.registerStyle("page-list", com.corbettcode.allaboutrocks.PageListStyle)
        ctx.theme.registerStyle("hero-container", com.corbettcode.allaboutrocks.HeroContainerStyle)
        ctx.theme.registerVariant("-circle", com.corbettcode.allaboutrocks.CircleButtonVariant)
        ctx.theme.registerVariant("-uncolored", com.corbettcode.allaboutrocks.UncoloredButtonVariant)
        ctx.theme.registerKeyframes("side-menu-slide-in", com.corbettcode.allaboutrocks.components.sections.SideMenuSlideInAnim)
        com.corbettcode.allaboutrocks.initTheme(ctx)
        com.corbettcode.allaboutrocks.initSiteStyles(ctx)
        com.corbettcode.allaboutrocks.initColorMode(ctx)
        com.corbettcode.allaboutrocks.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.corbettcode.allaboutrocks.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
